import {Component, ElementRef, inject, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {PortfolioCardComponent} from "../portfolio-card/portfolio-card.component";
import {MatButton} from "@angular/material/button";
import {DragScrollItemDirective} from "ngx-drag-scroll";
import {WorkStore} from "./store/work-store";

@Component({
  selector: 'app-works',
  templateUrl: './works.component.html',
  styleUrls: ['./works.component.scss'],
  imports: [
    MatIcon,
    PortfolioCardComponent,
    MatButton,
    DragScrollItemDirective
  ],
  providers: [WorkStore]
})
export class WorksComponent {

  private router = inject(Router);

  readonly #store: any = inject(WorkStore);

  protected readonly works = this.#store.works;

  @ViewChild('list') list!: ElementRef;
  // We want to know the width of one of the items. We'll use this to decide how many pixels we want our carousel to scroll.
  item = document.querySelector(".item");
  itemWidth: number = 400;

  handleClick(direction: any) {
    // Based on the direction we call `scrollBy` with the item width we got earlier
    if (direction === "previous") {
      this.list.nativeElement.scrollBy({left: -this.itemWidth, behavior: "smooth"});
    } else {
      this.list.nativeElement.scrollBy({left: this.itemWidth, behavior: "smooth"});
    }
  }

  navigateToPortfolio() {
    this.router.navigate(["/case-studies"]);
  }

  navigateToCase(id: number) {
    this.router.navigate([`/case-studies/${id}`])
  }
}
